import {FC} from 'react'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {TableGuestsListWrapper} from '../Tables/TableGuestList'

const HeaderGuestListPanel: FC = () => {
  return (
    <>
      <div className='sdx_content_tab_panel'>
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Listado de Huéspedes</Tab>
          </TabList>
          <TabPanel>
            <TableGuestsListWrapper />
          </TabPanel>
        </Tabs>
      </div>
    </>
  )
}

export {HeaderGuestListPanel}
